import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "home",
  style: {"height":"95vh"}
}
const _hoisted_2 = { class: "mb-2 text-h4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "mb-2 text-h5" }, "Sistema de consulta del log de peritos", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "mb-2 text-h5" }, "Sistema de consulta del padrón de peritos", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "mb-2 text-h5" }, "Consulta de agrupaciones y profesiones", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_avatar = _resolveComponent("q-avatar")
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")
  const _component_q_toolbar = _resolveComponent("q-toolbar")
  const _component_q_tab = _resolveComponent("q-tab")
  const _component_q_tabs = _resolveComponent("q-tabs")
  const _component_q_header = _resolveComponent("q-header")
  const _component_busqueda_asignaciones = _resolveComponent("busqueda-asignaciones")
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")
  const _component_padron_inscripciones = _resolveComponent("padron-inscripciones")
  const _component_busqueda_profesiones = _resolveComponent("busqueda-profesiones")
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")
  const _component_q_layout = _resolveComponent("q-layout")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_q_layout, {
      view: "lHh lpr lFf",
      container: "",
      style: {"min-height":"500px","height":"100%"},
      class: "shadow-2 rounded-borders"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_header, { elevated: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_avatar, {
                  icon: "account_balance",
                  size: "4rem",
                  "font-size": "2.5rem"
                }),
                _createVNode(_component_q_toolbar_title, null, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_2, "Consultas de peritos" + _toDisplayString(_ctx.env ? ` - ${_ctx.env}` : ''), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_tabs, {
              modelValue: _ctx.tab,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tab, {
                  name: "log",
                  label: "Log de sorteos"
                }),
                _createVNode(_component_q_tab, {
                  name: "padron",
                  label: "Padrón de inscripciones"
                }),
                _createVNode(_component_q_tab, {
                  name: "profesiones",
                  label: "Listado de agrupaciones/profesiones"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_tab_panels, {
          modelValue: _ctx.tab,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.tab = $event)),
          animated: "",
          swipeable: "",
          style: {"height":"95vh","padding-top":"15vh"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tab_panel, { name: "log" }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_busqueda_asignaciones)
              ]),
              _: 1
            }),
            _createVNode(_component_q_tab_panel, {
              name: "padron",
              class: "q-pa-md"
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createVNode(_component_padron_inscripciones)
              ]),
              _: 1
            }),
            _createVNode(_component_q_tab_panel, {
              name: "profesiones",
              class: "q-pa-md"
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_busqueda_profesiones)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}